import { useIsICRAResearchAssistBranding } from "@needl-ai/common/branding";

const Copyright = () => {
  const isICRAResearchAssist = useIsICRAResearchAssistBranding();

  if (!isICRAResearchAssist) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 text-center py-1.5 text-xs text-muted-foreground pointer-events-none">
      Copyright © 2026 ICRA Limited. All Rights Reserved
    </div>
  );
};

export default Copyright;
